import React from 'react';
import styled from 'styled-components';
import { publicImageUrl } from '../../../lib/publicImageUrl';
import Attribution from '../../../../shared/components/Attribution';
import colors from '../../../../shared/settings/colors';
import { only, between } from '../../../../shared/spa/core-components/utils/media';

const HeroImg = styled.div`
    position: absolute;
    z-index: 10;
    top: 150px;
    align-items: center;
    flex-direction: column;

    ${between('small', 'medium')} {
        display: none;
    }

    ${only('normal')} {
        left: 50em;
    }

    ${only('large')} {
        left: 60%;
    }
`;

const RoundCameraDecorator = styled.div`
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: ${colors.grey100};
    display: block;
    margin: 10px 0 10px 0;
`;

const LaptopBackground = styled.div`
    background-color: ${colors.white};
    width: 900px;
    margin: 0 60px 1px 60px;
    padding: 0 20px 20px 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 15px 15px 0 0;
    box-shadow: 0 20px 60px 0 rgba(28, 27, 26, 0.2), 0 20px 60px 0 rgba(28, 27, 26, 0.19);
`;

const LaptopBottomDecorator = styled.div`
    border-top: 10px solid ${colors.grey100};
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    height: 0;
    width: 200px;
`;

const LaptopBottom = styled.div`
    height: 30px;
    width: 1000px;
    border-radius: 0 0 500rem 500rem;
    background-color: ${colors.white};
    display: flex;
    justify-content: center;
`;

const AttributionWrapper = styled.div`
    margin-left: 60px;
    margin-top: 5px;
`;

export interface LaptopHeroImageProps {
    designer: string;
    src: string;
    altText: string;
}

export default function LaptopHeroImage({ src, altText, designer }: LaptopHeroImageProps) {
    return (
        <HeroImg>
            <LaptopBackground>
                <RoundCameraDecorator />
                <img src={publicImageUrl(src)} alt={altText} />
            </LaptopBackground>
            <LaptopBottom>
                <LaptopBottomDecorator></LaptopBottomDecorator>
            </LaptopBottom>
            <AttributionWrapper>
                <Attribution name={designer} />
            </AttributionWrapper>
        </HeroImg>
    );
}
